export const GET_RULES = 'Get_Rules';